import React from 'react';
import {withNamespaces} from 'react-i18next';

const Textarea = ({t, type, id, error, label, value, onChange, placeholder, className: customClass}) => {
  const className = (!error ? 'form-control' : 'form-control is-invalid') + (customClass ? ' ' + customClass : '');

  return (
    <div className="mb-4">
      {
        label !== false
          ? (
            <label htmlFor={id}>
              {t('form.' + id + '.label')}
            </label>
          )
          : null
      }
      
      <textarea
        type={type}
        name={id}
        id={id}
        className={className}
        value={value}
        onChange={onChange}
        placeholder={placeholder}>
      </textarea>
      <div className="invalid-feedback">
        {error}
      </div>
    </div>
  );
};

export default withNamespaces()(Textarea);